<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    :title="title"
    top="8vh"
    width="800px"
  >
    <TableSelect
      ref="tableSelect"
      :filter="filter"
      :columns="columns"
      module="basic"
      :url="url"
      @select="selectHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item v-for="item in searchItems" :key="item.key" :label="item.label">
            <el-input v-model.trim="filter[item.key]" :placeholder="item.placeholder || '请输入'" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  props: {
    title: {
      type: String,
      default: "选择",
    },
    url: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    searchItems: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
        this.$refs.tableSelect.loadData(1);
      });
    },
    selectHandle(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },
    resetHandle(filter) {
      for (let key in filter) {
        this.filter[key] = filter[key];
      }
      this.$refs.tableSelect.loadData(1);
    },
  },
};
</script>
